import React from 'react'
import Main from './Main'

const CanteensAdmin = () => {
  return <Main />
}

export default CanteensAdmin
